/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const DownloadSimpleOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M8.06 10.32 12 14.25m0 0 3.94-3.93M12 14.25V3.75m8.25 10.5v5.25a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-5.25"
})); // Fill


const DownloadSimpleFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M7.53 10.85a.824.824 0 0 1-.2-.38c-.03-.15-.02-.3.04-.44.05-.13.15-.25.27-.34.13-.08.27-.12.42-.12h3.19V3.75a.75.75 0 0 1 1.5 0v5.82h3.19c.15 0 .29.04.42.12.12.09.22.21.27.34.06.14.07.29.04.44-.03.14-.1.27-.2.38l-3.94 3.94c-.14.14-.33.21-.53.21s-.39-.07-.53-.21l-3.94-3.94zm12.72 2.65a.75.75 0 0 0-.75.75v5.25h-15v-5.25a.75.75 0 0 0-1.5 0v5.25A1.499 1.499 0 0 0 4.5 21h15a1.499 1.499 0 0 0 1.5-1.5v-5.25a.75.75 0 0 0-.75-.75z"
})); // DuoTone


const DownloadSimpleDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M8.06 10.32 12 14.25m0 0 3.94-3.93M12 14.25V3.75m8.25 10.5v5.25a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-5.25"
}));
/**
  Icon DownloadSimpleIcon in system group
*/


export const DownloadSimpleIcon = createIcon('DownloadSimpleIcon', 'download-simple', 'system', DownloadSimpleOutline, DownloadSimpleFill, DownloadSimpleDuotone, "0 0 24 24");